import { render, staticRenderFns } from "./CreateTeamModal.vue?vue&type=template&id=372db1db&lang=pug"
import script from "./CreateTeamModal.vue?vue&type=script&lang=js"
export * from "./CreateTeamModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports